module.exports = __webpack_public_path__ + "img/profit.b5664d9e.png";